import './BeginGoLive.scss';
import Card from 'components/chrome/Card';
import React from 'react';
import { Redirect } from 'react-router';


class BeginGoLive extends React.Component {

  constructor() {
    super();
    this.state = {};
  }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect push to={this.state.redirect} />
      );
    }

    return (
      <div className='BeginGoLive'>
        <div className='section'>
          <div className='subtitle'>
            Bring your device to life
          </div>
          <p>
            Review advice from our experts and the wider community to help you achieve a successful launch.
          </p>
        </div>
        <div className='section'>
          <div className='p-grid'>
            <div className='p-col-12'>
              <Card
                  direction='horizontal'
                  header='Connect with the community'
                  text='See examples in our library, visit the community forums, and speak with an expert.'
                  buttonPrimaryLabel='Connect'
                  buttonPrimaryAction={() => this.setState({redirect: '/help'})}
                  />
            </div>
            <div className='p-col-12'>
              <Card
                  header='Regulatory best practices'
                  direction='horizontal'
                  text='Browse our latest blog articles and recommended readings.'>
                {/*
                <div className='article'>
                  <div className='articleTitle'>Regulatory article 1</div>
                  <div className='articleAuthor'>So-and-So</div>
                  <div className='articleLede'>So-and-So</div>
                  <div className='articleCta'>
                    Continue
                  </div>
                </div>
                */}
              </Card>
            </div>
            <div className='p-col-12'>
              <Card
                  header='Cybersecurity best practices'
                  direction='horizontal'
                  text='Browse our latest blog articles and recommended readings.' />
            </div>
            <div className='p-col-12'>
              <Card
                  header='Production environment best practices'
                  direction='horizontal'
                  text='Browse our latest blog articles and recommended readings.' />
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default BeginGoLive;
